export default __webpack_public_path__ + "static/media/img7.799f60b3.jpg";